
export function ITEMS_SAVE_ONE (state, item) {
  state.all[item.id] = item
}

export function ITEMS_SAVE_BATCH (state, promise) {}

export function ITEMS_DELETE_ALL (state) {
 state['all'] = {}
}

export function ITEMS_SAVE_AUTOCOMPLETE (state, items) {
 state['autocomplete'] = items
}

export function ITEMS_SET_FOR_CATEGORY (state, { items, categoryId }) {
  if (!state.categories[categoryId]) {
    state.categories[categoryId] = {}
  }

  if(categoryId === 'uncategorized') {
    state.categories[categoryId] = items.filter(item => {
      const cats = item.get('categories')
      console.log('item', item, cats, !cats, !cats[0])
      return !cats || !cats[0]
    })
  } else {
    state.categories[categoryId] = items
  }

  for (const i in items) {
    state.all[items[i].id] = items[i]
  }
}

export function ITEMS_SAVE_SPECIALS (state, items) {
 state['specials'] = items
}

export function ITEMS_SET_WARNINGS (state, warnings) {
  const warningsById = {}
  for (const i in warnings) {
    warningsById[warnings[i].id] = warnings[i]
  }
 state['warnings'] = warningsById
}

export function ITEMS_SET_ITEM_EXTRAS (state, { itemId, extras }) {
  state.extrasByItem[itemId] = extras

  for (const i in extras) {
    state.extras[extras[i].id] = extras[i]
  }
}

export function ITEMS_LOADING (state, status) {
 state['loading'] = status
}

export function ITEMS_WARNINGS_LOADING (state, status) {
 state['warningsLoading'] = status
}

export function ITEMS_EXTRAS_LOADING (state, status) {
 state['extrasLoading'] = status
}
